// require('./bootstrap');
window._ = require('lodash');
window.$ = window.jQuery = require('jquery');

window.UIkit = require("uikit");
window.Icons = require("uikit/dist/js/uikit-icons");
import Pikaday from 'pikaday'
import select2 from 'select2';
import moment from 'moment';
window.select2 = select2;
window.Pikaday = Pikaday;
window.moment = moment;
UIkit.use(window.Icons);

import intlTelInput from 'intl-tel-input';
window.intlTelInput = intlTelInput;


require('./animejs');


window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


import Home from './Home';
import Header from './Header';
Header.Animation();
Home();


$(function (){
    if(settings.redirect === true && !localStorage.getItem('show_popup')){
        let modal = UIkit.modal('#country-check');
        setTimeout(()=>{
            modal.show();

        },8000)

        UIkit.util.on('#country-check', 'hidden', function () {
            localStorage.setItem('show_popup','no');
        });

        $('.country-no').on('click',function (e){
            modal.hide();
            localStorage.setItem('show_popup','no');
            e.preventDefault();
        })
    }
})

